import { CLSLogType } from "../../../enums/log/clsLogType";
import { Log } from "../../../models/logging/log";

export const getStartPageRevisionsLog = {
  msg: "Track",
  level: "info",
  cprNumber: "9902309701",
  clsRequest: {
    aftaleId: "config",
    requestId: "abc-test",
    modulId: "web-dev-local",
    modulNavn: "ELO TSB",
    logType: CLSLogType.RevisionsLog,
    dataSletSenest: "indsigt",
    body: '{"actionType":"Start låneansøgnings forløb","data":{"transactionId":"111111111.1","properties":[{"guid":"c63f3ace-1353-4402-83d0-4e8192cd25e4","bfeNumber":"8923139829","address":"Sydvestvej, 12, A, 7100, Vejle"},{"guid":"55e06970-5e10-437f-ac04-c6122b0aff8b","bfeNumber":"100000019","address":"Sydvestvej, 118, A, 2700, Kruså"},{"guid":"75482a3a-202d-4115-a925-dafbebaf6b36","bfeNumber":"100000020","address":"Sydvestvej, 119, A, 2700, Kruså"},{"guid":"a2f92482-9eb7-4ca8-8ff7-aedf66cc9fe6","bfeNumber":"100000021","address":"Sydvestvej, 120, A, 2700, Kruså"}]}}',
  },
  page: "Ansøg om pensionistlån",
} as Log;

export const getStartPageApplicationLog = {
  msg: "Logging request from getProperty",
  level: "info",
  stacktrace: "",
  cprNumber: "9902309701",
  clsRequest: {
    aftaleId: "config",
    requestId: "vBMrR2zT0E6FCfbcNDmIC",
    modulId: "web-dev-local",
    modulNavn: "ELO TSB",
    logType: CLSLogType.ApplikationsLog,
    dataSletSenest: "indsigt",
    body: '{"cprNumber":"9902309701","request":"{\\"cache\\":\\"default\\",\\"credentials\\":\\"same-origin\\",\\"destination\\":\\"\\",\\"integrity\\":\\"\\",\\"keepalive\\":false,\\"method\\":\\"GET\\",\\"mode\\":\\"cors\\",\\"redirect\\":\\"follow\\",\\"referrer\\":\\"about:client\\",\\"referrerPolicy\\":\\"\\",\\"url\\":\\"https://www.tastselv.skat.dk.csc.dk/elo/api/dev/edp/edp-data/citizen-properties?cprNumber=9902309701&transactionId=111111111&returnCompanies=false\\"}","response":"{\\"ok\\":true,\\"redirected\\":false,\\"status\\":200,\\"statusText\\":\\"OK\\",\\"type\\":\\"basic\\",\\"url\\":\\"https://www.tastselv.skat.dk.csc.dk/elo/api/dev/edp/edp-data/citizen-properties?cprNumber=9902309701&transactionId=111111111&returnCompanies=false\\"}"}',
  },
} as Log;

export const getStartPageAdministratorLog = {
  msg: "Track",
  level: "info",
  cprNumber: "9902309701",
  clsRequest: {
    aftaleId: "config",
    requestId: "abc-test",
    modulId: "web-dev-local",
    modulNavn: "ELO TSB",
    logType: CLSLogType.AdministratorLog,
    dataSletSenest: "audit",
    body: '{"actionType":"Start låneansøgnings forløb"}',
  },
  page: "Ansøg om pensionistlån",
} as Log;
